import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { Icon, SafeHtmlPipe } from '@millionshow/client-libs';
import { FaqService } from '@millionshow/api-client';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NotFoundComponent } from '../../../../components/not-found/not-found.component';

@Component({
  selector: 'app-faq',
  imports: [CommonModule, Icon, SafeHtmlPipe, NotFoundComponent],
  templateUrl: './faq.component.html',
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0',
          opacity: '0',
          overflow: 'hidden',
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: '1',
          overflow: 'hidden',
        })
      ),
      transition('collapsed <=> expanded', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)'),
      ]),
    ]),
    trigger('rotateChevron', [
      state(
        'down',
        style({
          transform: 'rotate(90deg)',
        })
      ),
      state(
        'up',
        style({
          transform: 'rotate(-90deg)',
        })
      ),
      transition('down <=> up', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)'),
      ]),
    ]),
  ],
})
export default class FaqComponent {
  private readonly faqService = inject<FaqService>(FaqService);

  openStates = signal<Record<string, boolean>>({});

  $data = rxResource({
    stream: () => {
      return this.faqService.faqControllerSearchV1({
        pageNo: 1,
        pageSize: 5,
        isPinned: true,
        isExposed: true,
        target: 'GENERAL' as const,
        type: 'MILLIONSHOW' as const,
      });
    },
  });

  faqs = computed(() => {
    const data = this.$data.value();
    return data?.items || [];
  });

  loading = computed(() => this.$data.isLoading());

  toggleFaq(id: string) {
    this.openStates.update(states => ({
      ...states,
      [id]: !states[id],
    }));
  }

  isOpen(id: string): boolean {
    return this.openStates()[id] || false;
  }

  stripHtml(html: string): string {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  }
}
